export const { format: getNumberWithCommas } = new Intl.NumberFormat('en-US')

// use:
// internationalNumberFormat.format(givenNumber)
